import type { CommandBusPort, CommandContract } from '@ochal/module-sdk/contracts';

type Handler = (payload: never) => Promise<unknown>;
export class CommandRegistrationError extends Error { constructor(message: string) { super(message); this.name = 'CommandRegistrationError'; } }
export class TypedCommandBus<Commands extends object> implements CommandBusPort<Commands> {
  private readonly handlers = new Map<Extract<keyof Commands, string>, Handler>();
  register<K extends Extract<keyof Commands, string>>(command: K, handler: (payload: Commands[K] extends CommandContract<infer P, unknown> ? P : never) => Promise<Commands[K] extends CommandContract<unknown, infer R> ? R : never>): () => void {
    if (this.handlers.has(command)) throw new CommandRegistrationError(`Command already registered: ${command}`);
    this.handlers.set(command, handler as Handler);
    return () => { this.handlers.delete(command); };
  }
  async execute<K extends Extract<keyof Commands, string>>(command: K, payload: Commands[K] extends CommandContract<infer P, unknown> ? P : never): Promise<Commands[K] extends CommandContract<unknown, infer R> ? R : never> {
    const handler = this.handlers.get(command);
    if (!handler) throw new CommandRegistrationError(`Command handler not found: ${command}`);
    return await handler(payload as never) as Commands[K] extends CommandContract<unknown, infer R> ? R : never;
  }
}
